/**
 * Created by andrey on 23.04.2024
 */

const Transition = {
    ZORDER: 1000,

    create: function (fromScene) {
        const transition = Prefab.instantiate(bundles.transition.jsons.transition_prefab_json, {
            theme: bundles.transition.jsons.transition_theme_json
        });

        transition.setVisible(false);

        fromScene.addChild(transition);

        return transition;
    }
};
